<template>
    <b-notification type="is-danger" has-icon icon-pack="fas" role="alert">
        <h4 class="is-size-4 has-text-weight-bold">Ops... Algo errado.</h4>

        <br>
        <p>
            Ocorreu um erro ao redirecionar para {{ dynamicRedirect }}. Tente novamente mais tarde. Lamentamos o incoveniente.
        </p>
        <br>
        <p class="is-size-7">
            <b>É administrador do sistema?</b><br>
            Há um erro de configuração nas variáveis do sistema. Configure-o corretamente e, se preciso, contate o suporte.
        </p>
    </b-notification>
</template>

<script>
export default {
    name: 'ErrorNotification',
    props: {
        login: Boolean,
        register: Boolean,
    },
    computed: {
        dynamicRedirect() {
            return this.login ? 'a tela de login' : this.register ? 'a tela de cadastro' : 'outra página'
        },
    },
}
</script>